<template>
  <div class="credential-realtime-view__container">
    <div
      class="credential-realtime-view__back-button sticky"
      v-show="viewLimit > 50 && !currentIdentityId"
      @click="viewLimit = 50"
      >
      show less
    </div>
    <virtual-list
      :size="230"
      :remain="remain || 10"
      wtag="ul"
      infinite-wrapper
      >
      <div
        class="credential-realtime-view__back-button"
        v-if="currentIdentityId"
        @click="setIdentityIDFilter(undefined)"
        >
        back
      </div>
      <div
        v-for="event in filteredDetections"
        :key="event.access_event_uuid"
        class="credential-realtime-view__card-container"
        >
        <realtime-event-card :event="event"/>
      </div>
      <div
        class="credential-realtime-view__back-button centered"
        v-if="viewLimit < sortedDetections.length && !currentIdentityId"
        @click="viewLimit += 50"
        >
        show more
      </div>
    </virtual-list>
  </div>
</template>

<script>
import VirtualList from 'vue-virtual-scroll-list'
import { AutoSizingList } from '@/mixins'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import RealtimeEventCard from './RealtimeEventCard'

export default {
  name: 'RealTimeView',
  components: {
    VirtualList,
    RealtimeEventCard,
  },
  mixins: [AutoSizingList],
  data () {
    return {
      accessEvents: {},
      viewLimit: 50,
    }
  },
  methods: {
    ...mapActions({
      getRealtimeCredentialMatches: 'realtimeCredentials/getRealtimeCredentialMatches',
    }),
    ...mapMutations({
      setIdentityIDFilter: 'realtimeCredentials/setIdentityIDFilter',
    }),
    async loadData () {
      this.getRealtimeCredentialMatches()
    },
    tenantFromEvent (event) {
      return {
        person_name: `${event.surname}, ${event.given_name}`,
        credential_uuid: event.credential_uuid,
      }
    },
  },
  computed: {
    filteredDetections () {
      const filtered = [...Object.values(this.sortedDetections)].filter(detection => {
        if (this.currentIdentityId) {
          return detection.credential_uuid === this.currentIdentityId
        } else return true
      })
      return filtered.splice(0, 50)
    },
    ...mapGetters({
      sortedDetections: 'realtimeCredentials/sortedDetections',
      currentIdentityId: 'realtimeCredentials/currentIdentityId',
    }),
  },
  mounted () {
    this.loadData()
    setInterval(function () {
      this.loadData()
      console.log('fetching data')
    }.bind(this), 90000)
  },
}
</script>

<style>
  .sticky {
    position: sticky;
    top: 0px;
    margin-left: 1rem;
  }

  .centered {
    margin-right: auto;
    margin-left: auto;
  }

  .credential-realtime-view__card-container {
    padding: 0rem 2.5rem 0rem 0rem;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .credential-realtime-view__container {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 1.5rem 1.5rem 0rem 0rem;
    height: 100%;
  }

  .credential-realtime-view__back-button {
    background-color: white;
    width: 6rem;
    cursor: pointer;
    border-radius: .5rem;
    text-align: center;
  }

</style>
